import { controllerHelpers, type Controller, type Listeners } from '../helpers';
import type { UpdateSingleBillManager } from '../managers';
import { singleBillPaymentMethodsEventBus } from '../managers';

export class SingleBillPaymentMethodsController implements Controller {
  public listeners: Listeners;

  constructor(private updateSingleBill: UpdateSingleBillManager) {
    this.listeners = controllerHelpers.createListeners([
      singleBillPaymentMethodsEventBus.bindTo('singleBillPaymentMethodCanBeUpdated', this.onPaymentMethodCanBeUpdated),
    ]);
  }

  private onPaymentMethodCanBeUpdated = async (canBeUpdated: boolean) => {
    if (this.updateSingleBill) {
      const api = await this.updateSingleBill.getApiWhenReady();

      api.reportPaymentCanBeUpdated(canBeUpdated);
    }
  };
}
